import { parseDate } from "@internationalized/date";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ChevronLeftIcon } from "lucide-react";
import { Suspense } from "react";

import { Link } from "@/components/base/link";
import { title } from "@/components/base/primitives";
import { ProfileForm } from "@/components/users/profile-form";
import { useTRPC } from "@/integrations/trpc/react";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/profile/$profileId/edit")({
  loader: async ({ params: { profileId }, context: { queryClient, trpc } }) => {
    const result = await queryClient.ensureQueryData(
      trpc.profiles.get.queryOptions({
        id: Number.parseInt(profileId, 10),
      }),
    );

    return result;
  },
  head: () => ({
    meta: [{ title: "Update Profile" }],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { profileId } = Route.useParams();
  const trpc = useTRPC();

  const { data } = useSuspenseQuery({
    ...trpc.profiles.get.queryOptions({
      id: Number.parseInt(profileId, 10),
    }),
    select: (data) => {
      return {
        ...data,
        birthdate: parseDate(data.birthdate),
      };
    },
  });

  return (
    <DefaultLayout classNames={{ content: "relative" }}>
      <div className="relative mx-auto flex max-w-lg flex-col space-y-16 px-3 py-16 md:py-12">
        <h1 className={title({ className: "text-center" })}>Update Profile</h1>

        <div className="mx-auto w-full max-w-lg rounded-lg bg-white p-8">
          <Suspense fallback={<>Nope</>}>
            {data && (
              <ProfileForm
                profileId={data.id}
                initialValues={data ?? null}
                isEdit={true}
              />
            )}
          </Suspense>
        </div>
      </div>
      <Link
        className="absolute top-3 left-0 flex flex-row gap-2 md:top-6 md:left-6"
        to="/profile/$profileId"
        params={{
          profileId,
        }}
      >
        <ChevronLeftIcon /> <span>Back to profile</span>
      </Link>
    </DefaultLayout>
  );
}
